import React, { memo, useMemo } from 'react';
import dayjs from 'dayjs';
import classnames from 'classnames';
import type { ReactNode } from 'react';
import styles from './index.module.scss';

export type ChartHeaderProps = {
  title?: ReactNode;
  titleFontSize?: number;
  subTitle?: ReactNode;
  extra?: ReactNode;
  dateSubTitle?: boolean;
  date?: string;
  className?: string;
  subTitleClassName?: string;
  subTitleFontColor?: string;
};

const ChartHeader: React.FC<ChartHeaderProps> = ({
  title,
  titleFontSize = 16,
  subTitle,
  extra,
  dateSubTitle = false,
  date = dayjs().format('YYYY-MM'),
  className,
  subTitleClassName,
  subTitleFontColor,
}) => {
  const subTitleContent = useMemo(
    () => subTitle || (dateSubTitle && `统计周期 ${date}`),
    [date, dateSubTitle, subTitle]
  );
  const titleContent = useMemo(
    () =>
      typeof title === 'string' ? (
        <h2 className={styles.title} style={{ fontSize: titleFontSize }}>
          {title}
        </h2>
      ) : (
        <span className={styles.title}>{title}</span>
      ),
    [title, titleFontSize]
  );
  return (
    <>
      <div className={classnames(styles.header, className)}>
        {title && titleContent}
        {/* {title &&
          (typeof title === 'string' ? (
            <h2 className={styles.title} style={{ fontSize: titleFontSize }}>
              {title}
            </h2>
          ) : (
            { title }
          ))} */}
        {subTitleContent && (
          <span style={{ color: subTitleFontColor }} className={classnames(styles.subTitle, subTitleClassName)}>
            {subTitleContent}
          </span>
        )}
        {extra}
      </div>
    </>
  );
};

export default memo(ChartHeader);
